import axios from "axios"

export const getDictionaries = () =>
  axios.get("/api/dictionaries/getDictionaries").then((response) => response.data)
